import { InstitutionalClaimServices } from './InstitutionalClaimServices'
import { PhysicianClaimServices } from './PhysicianClaimServices'

interface ClaimServicesProps {
    data: any
}

export const ClaimServices = (props: ClaimServicesProps) => {
    const { data } = props
    if (data.claim !== undefined && data.claim?.publicData.admissionTypeCode) {
        return <InstitutionalClaimServices data={data} />
    } else {
        return <PhysicianClaimServices data={data} />
    }
}
